import SearchIcon from 'src/assets/magnifying-icon.svg';

import { FormComponent } from 'components/FormComponent';

import classes from './searchbar.module.css';

type SearchBarProps = {
  query: string;
  setQuery: (query: string) => void;
};
export const SearchBar = ({ query, setQuery }: SearchBarProps) => {
  return (
    <div className={classes.searchContainer}>
      <FormComponent.Input
        id="search"
        className={classes.searchbar}
        placeholder="Search"
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <img src={SearchIcon} alt="Search" className={classes.searchIcon} />
    </div>
  );
};
